<template>
  <v-col>
    <v-app-bar flat color="transparent">
      <v-toolbar-title class="title accent--text">
        {{ device.setDeviceName }}
      </v-toolbar-title>
      <v-badge
        :color="onlineColor(device.LastUpdateUnix, device.sleepSeconds)"
        dot
        offset-x="-10"
        offset-y="5"
      >
      </v-badge>
    </v-app-bar>
    <v-row>
      <v-col v-if="device.Temp && device.Temp > 0" cols="6" md="3">
        <v-card class="rounded-xl" color="primary" outlined align="center">
          <v-toolbar flat>
            <v-toolbar-title class="subtitle-2 accent--text">
              Temperature
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <span class="text-h5 pa-0 accent--text" cols="12">
              <span class="font-weight-medium">{{ device.Temp }}</span>
              <small class="font-weight-light">°C</small>
            </span>
          </v-toolbar>
          <v-card-text class="pa-0">
            <v-row align="center" class="white--text text-no-wrap pa-4">
              <v-col cols="12" class="pa-0">
                <div>
                  <v-icon left color="white">mdi-weather-sunny</v-icon>
                  {{ device.TempMax }}°C
                </div>
                <div>
                  <v-icon left color="white">mdi-snowflake</v-icon>
                  {{ device.TempMin }}°C
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col v-if="device.Humidity && device.Humidity > 0" cols="6" md="3">
        <v-card class="rounded-xl" color="primary" outlined align="center">
          <v-toolbar flat>
            <v-toolbar-title class="subtitle-2 accent--text">
              Humidity
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <span class="text-h5 pa-0 accent--text" cols="12">
              <span class="font-weight-medium">{{ device.Humidity }}</span>
              <small class="font-weight-light">%</small>
            </span>
          </v-toolbar>
          <v-card-text class="pa-0">
            <v-row align="center" class="white--text text-no-wrap pa-4">
              <v-col cols="12" class="pa-0">
                <div>
                  <v-icon left color="white">
                    mdi-arrow-up-bold-outline
                  </v-icon>
                  {{ device.HumidityMax }}%
                </div>
                <div>
                  <v-icon left color="white">
                    mdi-arrow-down-bold-outline
                  </v-icon>
                  {{ device.HumidityMin }}%
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col v-if="device.Pressure && device.Pressure > 0" cols="6" md="3">
        <v-card class="rounded-xl" color="primary" outlined align="center">
          <v-toolbar flat>
            <v-toolbar-title class="subtitle-2 accent--text">
              Pressure
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <span class="text-h5 pa-0 accent--text" cols="12">
              <span class="font-weight-medium">{{ device.Pressure }}</span>
              <small class="font-weight-light">hPa</small>
            </span>
          </v-toolbar>
          <v-card-text class="pa-0">
            <v-row align="center" class="white--text text-no-wrap pa-4">
              <v-col cols="12" class="pa-0">
                <div>
                  <v-icon left color="white">
                    mdi-arrow-up-bold-outline
                  </v-icon>
                  {{ device.PressureMax }}hPa
                </div>
                <div>
                  <v-icon left color="white">
                    mdi-arrow-down-bold-outline
                  </v-icon>
                  {{ device.PressureMin }}hPa
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col v-if="device.Moisturepercent" cols="6" md="3">
        <v-card class="rounded-xl" color="primary" outlined>
          <v-toolbar flat>
            <v-toolbar-title class="subtitle-2 accent--text">
              Moisture
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <span class="text-h5 pa-0 accent--text" cols="12">
              <span class="font-weight-medium">{{
                device.Moisturepercent
              }}</span>
              <small class="font-weight-light">%</small>
            </span>
          </v-toolbar>
        </v-card>
      </v-col>
      <v-col cols="6" md="3">
        <v-card class="rounded-xl" color="primary" outlined>
          <v-toolbar flat>
            <v-toolbar-title class="subtitle-2 accent--text">
              Battery Charge
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <span class="text-h5 pa-0 accent--text" cols="12">
              <span class="font-weight-medium">{{
                device.BatVoltagePercent
              }}</span>
              <small class="font-weight-light">%</small>
            </span>
          </v-toolbar>
          <v-card-text class="pa-0">
            <span class="font-weight-light white--text px-3">Last 3 days</span>
            <v-sparkline
              class="mt-n3"
              :value="batteryChart"
              :gradient="gradient"
              :smooth="radius || false"
              :padding="padding"
              :line-width="width"
              :stroke-linecap="lineCap"
              :gradient-direction="gradientDirection"
              :fill="fill"
              :type="type"
              :auto-line-width="autoLineWidth"
              auto-draw
            ></v-sparkline>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import moment from "moment";
import {
  computedOnlineStatusText,
  computedOnlineStatusColor,
} from "@/components/atoms/OnlineStatus.js";

export default {
  props: ["device", "chartData"],
  data() {
    return {
      width: 2,
      radius: 10,
      padding: 8,
      lineCap: "round",
      gradient: ["purple", "violet"],
      value: [0, 2, 5, 9, 5, 10, 3, 5, 0, 0, 1, 8, 2, 9, 0],
      gradientDirection: "top",
      fill: false,
      type: "trend",
      autoLineWidth: false,
      fromDate: moment()
        .subtract(3, "days")
        .format("YYYY-MM-DD"),
      toDate: moment()
        .add(1, "days")
        .format("YYYY-MM-DD"),
    };
  },
  computed: {
    batteryChart() {
      const vBat = new Array();
      const fromDate = moment(this.fromDate).format("X");
      const toDate = moment(this.toDate).format("X");

      const dataValues = this.chartData.filter((item) => {
        var date = item.TimeUnix;
        return date >= fromDate && date <= toDate;
      });

      dataValues.forEach((element) => {
        vBat.push(Number(element.vBat));
      });

      return vBat;
    },
  },
  methods: {
    onlineStatus(update, sleep) {
      return computedOnlineStatusText(update, sleep);
    },
    onlineColor(update, sleep) {
      return computedOnlineStatusColor(update, sleep);
    },
  },
};
</script>
